import UserProfile from "../features/user/UserProfile";

export default function ProfilePage() {
  return (
    <div className="container">
      <UserProfile />
    </div>
  );
}
